module.exports = __webpack_public_path__ + "img/logo.abdbb93f.png";